import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, NgModule, Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable, } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Menu, Breadcrumb } from '../class/appinterface';
import { environment } from '../../environments/environment';
import { Apiservice } from './api.service';
import { Router, ActivatedRouteSnapshot, Data, NavigationEnd, } from '@angular/router';
import { AnacomuniComponent } from '../components/anagrafiche/anacomuni/anacomuni.component';
import { CerComponent } from '../components/anagrafiche/cer/cer.component';




@Injectable({
  providedIn: 'root'
})
export class NicaMenuService {

  dataByEvent: EventEmitter<[]> = new EventEmitter<[]>();
  menuJson: Menu = {};
  components: any = []
  breadcrumbs_temp: any;

  constructor(private httpClient: HttpClient, private Apiservice: Apiservice, private Router: Router) {

    this.components['AnacomuniComponent'] = AnacomuniComponent;
    this.components['CerComponent'] = CerComponent;

  }


  //private _hoCambiatoMenu$ = new BehaviorSubject<any>(null);
  hoCambiatoMenu = new BehaviorSubject<any>('');

  private _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs = this._breadcrumbs$.asObservable();
  private preferMenu = new BehaviorSubject<Menu>({});
  menuPref = this.preferMenu.asObservable();
  private mainManu = new BehaviorSubject<Menu>({});
  menuMain = this.mainManu.asObservable();

  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();

  private _cronNavData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public cronNavData = this._cronNavData.asObservable();
  private _cronNavArray: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public cronNavArray = this._cronNavArray.asObservable();
 

  changeAzienda() {
    ////console.log(g(g("Cambio Azienda in MenuServices");
    this.getMenu();
  }


  getMenu() {

     

    const EndPoint = environment.BASE_API_URL + "Menu/GetAll";
    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .catch();
     
    return response

    /*.pipe(

        map(response=>{

            
            this.preferMenu.next(response); // change the value!
            this.mainManu.next(response)
            this.menuJson = response;
           
           
        })
    )*/


  }

  setVariabili(menu) {

    this.preferMenu.next(menu);
    this.mainManu.next(menu);
    this.menuJson = menu;


  }

  async updatePreferiti(itemMenu) {

    const EndPoint = environment.BASE_API_URL + "Menu/SetMenuPreferito?idMenu=" + itemMenu.id;
    const headers = this.Apiservice.httpOptionCall();



    const response = await this.httpClient.get(EndPoint, headers)
      .toPromise();
    this.getMenu();
    this.preferMenu.next(this.menuJson);  // change the value!)


  }





  getBreadcrumbs() {

    this.Router.events.pipe(
      // Filter the NavigationEnd events as the breadcrumb is updated only when the route reaches its end
      filter((event) => event instanceof NavigationEnd)
    ).subscribe(event => {
      // Construct the breadcrumb hierarchy
      const root = this.Router.routerState.snapshot.root;
      ////console.log(g(g(this.Router)
      const breadcrumbs: Breadcrumb[] = [];
      this.addBreadcrumb(root, [], breadcrumbs);

      // Emit the new hierarchy
      this._breadcrumbs$.next(breadcrumbs);


    });
  }

  private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
    ////console.log(g(g(route)
    if (route) {
      // Construct the route URL
      const routeUrl = parentUrl.concat(route.url.map(url => url.path));

      // Add an element for the current route part
      if (route.data.breadcrumb) {
        const breadcrumb = {
          label: this.getLabel(route.data),
          url: '/' + routeUrl.join('/')
        };
        breadcrumbs.push(breadcrumb);
      }

      // Add another element for the next route part
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    }
  }

  private getLabel(data: Data) {
    // The breadcrumb can be defined as a static string or as a function to construct the breadcrumb element out of the route data
    return typeof data.breadcrumb === 'function' ? data.breadcrumb(data) : data.breadcrumb;
  }
  setPreviousUrl(previousUrl: string) {
    ////console.log(g(g('previousUrl--->',previousUrl)
    this.previousUrl.next(previousUrl);
  }


  firstCronNav(cronav) {

    this.setCronNav(cronav)
  }

  setCronNav(infoUrl) {


    //////console.log(g(g(infoUrl)

    this._cronNavData.next(infoUrl)
  }

  setCronNavArray(arrNav) {


    this._cronNavArray.next(arrNav)

    sessionStorage.setItem('currentTabsItems', JSON.stringify(arrNav));
  }
  

  destroyCronNav() {
    // this._cronNavData.unsubscribe()

    this._cronNavData.next([])
  }
}
